import { Box, Stack, useColorScheme } from "@mui/material";
import moment from "moment-timezone";
import React from "react";
import { useTranslation } from "react-i18next"; // Added translation import
import { useI18nLanguage } from "../../hooks/i18nLanguage";
import { useSchedulerStore } from "../../state/scheduler.store";
import { getCanonicalTimezoneName } from "@rooster/utils";

interface IMeetingTimeProps {
  selectedTime: string | null;
  selectedTimezone: string | null;
  previouslySelectedTime?: string | null;
}

export const MeetingTime: React.FC<IMeetingTimeProps> = ({
  selectedTime,
  selectedTimezone,
  previouslySelectedTime
}) => {
  const { ui } = useSchedulerStore();
  const { t } = useTranslation(); // Added translation hook
  const { selectedLanguageForMoment } = useI18nLanguage();
  const { mode } = useColorScheme();

  // Use theme-aware colors for WCAG AA contrast compliance
  // Light mode: #1b5e20 on white (7.25:1 contrast)
  // Dark mode: #81c784 on #121212 (7.12:1 contrast)
  const successColor = mode === "dark" ? "#81c784" : "#1b5e20";

  return (
    <Stack sx={{ maxWidth: "320px" }} mb={1} spacing={2} direction="column">
      {previouslySelectedTime ? (
        <Box>
          {t("ROOSTER.PUBLIC-APP.PREVIOUSLY_SELECTED_TIME", {
            defaultValue: "Your previously selected time is "
          })}
          &nbsp;
          <strong style={{ color: successColor }}>
            <s>
              {moment(previouslySelectedTime)
                .tz(selectedTimezone ?? moment.tz.guess())
                .locale(selectedLanguageForMoment)
                .format("LLLL")}
            </s>
          </strong>
        </Box>
      ) : (
        <></>
      )}
      {selectedTime && ui?.currentStep !== "initial" && (
        <Box>
          {t("ROOSTER.PUBLIC-APP.CHOSEN_MEETING_TIME", {
            defaultValue: "You have chosen to meet on"
          })}
          &nbsp;
          <strong style={{ color: successColor }}>
            {moment(selectedTime)
              .tz(selectedTimezone ?? moment.tz.guess())
              .locale(selectedLanguageForMoment)
              .format("LLLL")}{" "}
            ({getCanonicalTimezoneName(selectedTimezone ?? moment.tz.guess())})
          </strong>
        </Box>
      )}
    </Stack>
  );
};
